import ReactDOM from 'react-dom/client'
import './index.css'
import './colors.scss'
import App from './App'

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <App/>
)
